module.exports = __webpack_public_path__ + "img/1960.3e94f7e4.png";